// German and global non-integer number is confusing
// 10.01 (GB) => 10,01 (DE)
// This function translates the non-integer number to global format

export const getNumber = (numberString: string): number => {
  const number = numberString.replace(',', '.');
  return Number(number);
};
